import { Dispatch, Reducer, ReducerAction, useEffect, useMemo } from 'react'
import { isProduction } from 'utilities/getEnv'

const applyLoggerToUseReducerDispatcher = <R extends Reducer<any, any>>(
    label: string,
    dispatcher: Dispatch<ReducerAction<R>>,
) => {
    const hookedDispatchFunc = (args: ReducerAction<R>) => {
        console.group(`\x1B[90;2m${label}:\x1B[m \x1B[93m${args.type}\x1B[m`)
        console.log(args)
        console.groupEnd()
        dispatcher(args)
    }

    return hookedDispatchFunc
}

/**
 * Apply logger to React's useReducer() dispatcher function.
 * @param label Text used for groupping message in console log
 * @param dispatcher Original dispatcher function returned from React's useReducer()
 * @param allowInProduction if TRUE will allow logger to be applied in production
 * @returns The new dispatcher function with an applied logger
 */
export const useApplyLoggerDispatch = <T>(
    label: string,
    dispatcher: Dispatch<T>,
    state: any,
    allowInProduction?: boolean,
): Dispatch<T> => {
    const hookedDispatchFunc = useMemo(() => {
        if (!isProduction() || allowInProduction)
            return applyLoggerToUseReducerDispatcher(label, dispatcher)

        return dispatcher
    }, [allowInProduction, dispatcher, label])

    useEffect(() => {
        if (!isProduction() || allowInProduction) console.log(label, { state })
    }, [allowInProduction, label, state])

    return hookedDispatchFunc
}
